import { Component, OnInit, Pipe, PipeTransform} from '@angular/core';
import { EmailEmbeddedImageSupportService } from '../../../services/common/email-embedded-image-support.service';
import { NotyService } from '../../../services/common/noty.service';
import {Observable, OperatorFunction} from 'rxjs';
import {debounceTime, distinctUntilChanged, map} from 'rxjs/operators';


@Component({
  selector: 'app-email-embedded-image-support-index',
  templateUrl: './email-embedded-image-support-index.component.html',
  styleUrls: ['./email-embedded-image-support-index.component.scss']
})
export class EmailEmbeddedImageSupportIndexComponent implements OnInit {

  search: OperatorFunction<string, readonly string[]> = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 2 ? []
        : this.autoCompleteDomains)
    )

  autoCompleteDomains: Array<any> = [];
  domains: Array<any> = [];
  searchTerm: String = '';
  domainName: String = '';
  emailEmbeddedImageSupport : Boolean = false;
  paginateParams: any = {
    page: 1,
    per_page: 5,
  };
  maxCount: number;

  constructor(private emailEmbeddedImageSupportService: EmailEmbeddedImageSupportService, private notyService: NotyService) {}

  ngOnInit() {
    this.emailEmbeddedImageSupportService
      .searchOptions({ search_options: true })
      .then((success) => {
        this.paginateParams.per_page = success.per_page;
        console.log('searchOptions success', success);
        this.index();
      })
      .catch((error) => {
        console.log("searchOptions error", error)
      });
    this.index()
  }

  index(pageEvent: any = null) {
    if (pageEvent) this.paginateParams.page = pageEvent.page;
    let { page, per_page } = this.paginateParams;
    this.emailEmbeddedImageSupportService
      .index({ page, per_page }).then((indexRe) => {
        console.log('indexRe', indexRe);
        indexRe.domains.forEach((element: any) => {
          element.isDeleting = false;
        });
        this.domains = indexRe.domains;
        this.maxCount = indexRe.count;
      })
      .catch((indexEr) => {
        console.log('index error', indexEr);
      });
  };

  searchDomains(pageEvent: any = null) {
    console.log('search term', this.searchTerm);
    if (pageEvent) this.paginateParams.page = pageEvent;
    let { page, per_page } = this.paginateParams;
    this.emailEmbeddedImageSupportService
      .index({name: this.searchTerm, page, per_page })
      .then((searchRes) => {
        console.log('search response', searchRes);
        this.domains = searchRes.domains;
      })
      .catch((searchErr) => {
        console.log('searchErr', searchErr);
      });
  };

  deleteDomain(domain: any, id: number) {
    domain.isDeleting = true;
    this.emailEmbeddedImageSupportService
      .delete({ id })
      .then((deleteRes) => {
        console.log('delete response', deleteRes);
        this.notyService.notify('Domain deleted', 'success');
        domain.isDeleting = false;
        this.index();
      })
      .catch((deleteErr) => {
        console.log('delete error', deleteErr);
      });
  };

  createDomain() {
    console.log("domainName",this.domainName);
    console.log("emailEmbeddedImageSupport", this.emailEmbeddedImageSupport);
    this.emailEmbeddedImageSupportService.create({ domain_name : this.domainName, embedded_image_support :  this.emailEmbeddedImageSupport}).then(createRe=>{
      if(createRe.status === 400){
        this.notyService.notify(createRe.result,"error");
      }
      else{
        this.notyService.notify("Domain added successfully","success");
        this.index();
      }
      console.log("createRe", createRe);
    }).catch(createEr=>{
      this.notyService.notify("createErr","error");
      console.log("createEr", createEr);
    })
  }

  updateDomain(id: number, embedded_image_support: any) {
    this.emailEmbeddedImageSupportService.update({ id, embedded_image_support :  !embedded_image_support}).then(updateRe=>{
      console.log("updateRe", updateRe);
      this.index();
    }).catch(updateEr=>{
      console.log("updateEr", updateEr);
    })
  }

  autoComplete() {
    this.emailEmbeddedImageSupportService.autocomplete({ term : this.searchTerm}).then(autoCompleteRe=>{
      console.log("autoCompleteRe", autoCompleteRe);
      this.autoCompleteDomains =  autoCompleteRe.map((domain: any) => { return domain.label})
      console.log("autoCompleteDomains", this.autoCompleteDomains);
    }).catch(autoCompleteEr=>{
      console.log("autoCompleteEr", autoCompleteEr);
    })
  }
}
